<script lang="ts">
  import { CommonTexts } from '../../services/CommonTexts';
  import { MenuService } from '../../services/MenuService.svelte';
  import Tooltip from '../tooltips/Tooltip.svelte';

  /**
   * A tag, everywhere the same: a small box `#Tag`, a click searches for it. No colour of its own: the background mixes the
   * text colour in, so it darkens the surface in the light mode and lightens it in the dark mode.
   */
  interface Props {
    /** The name of the tag, without `#`. */
    tag: string;
  }

  const { tag }: Props = $props();

  const Name = $derived(CommonTexts.getTagName(tag));
</script>

<Tooltip text={CommonTexts.Search}>
  <a class="tagBadge" href={MenuService.getSearchHref(Name)}>{Name}</a>
</Tooltip>

<style lang="scss">
  @use '../../../styles/mixins';

  .tagBadge {
    @include mixins.soft-badge();

    color: inherit;
    text-decoration: none;
    transition: background-color 0.15s linear;

    &:hover,
    &:focus-visible {
      background-color: color-mix(in srgb, currentcolor 18%, transparent);
    }
  }
</style>
